<div class="top">
  @if (isESTOnly) {
    <h5 class="tz-warning">
      ALL TIMES ON THIS PAGE ARE DISPLAYED IN EASTERN STANDARD TIME (EST)
      (UTC-5)
    </h5>
  } @else if (isMSTOnly) {
    <h5 class="tz-warning">
      ALL TIMES ON THIS PAGE ARE DISPLAYED IN MOUNTAIN STANDARD TIME (MST)
      (UTC-7)
    </h5>
  }
  <label class="label">{{ 'CRM.LABEL.START_DATE' | translate }}: </label>
  <p-datepicker
    [showButtonBar]="true"
    [ngModel]="startDate"
    dateFormat="yy-mm-dd"
    [disabled]="true"
  />
  <label class="label">{{ 'CRM.LABEL.END_DATE' | translate }}: </label>
  <p-datepicker
    [showButtonBar]="true"
    [ngModel]="endDate"
    dateFormat="yy-mm-dd"
    [disabled]="true"
    [minDate]="startDate"
  />
  <app-aor-select-panel
    id="aor-selector"
    (aorChanged)="aorChanged($event)"
    [aorName]="selectedAor()!.name"
    [selectedBusinessUnits]="selectedBusinessUnits()"
  />
  <app-actions-dropdown
    [availableActions]="availableActions"
    (actionSelected)="onActionSelected($event)"
    #actionsDropdown
  />
  <div class="hide-maintenance">
    <label for="hideMaintenance"
      >{{ 'CRM.LABEL.HIDE_MAINTENANCE' | translate }}:</label
    >
    <p-toggleswitch
      name="hideMaintenance"
      class="maintenance-switch"
      [(ngModel)]="hideMaintenance"
      (onChange)="refresh()"
    />
  </div>
  <button
    pButton
    pRipple
    type="button"
    label="Clear"
    icon="pi pi-fw pi-times"
    class="button p-button-success clear-button"
    (click)="clearScreen()"
  ></button>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-fw pi-refresh"
    class="button p-button-success refresh-button"
    (click)="refresh()"
  ></button>
</div>
<div class="break"></div>

<app-general-grid
  [values]="elements"
  [columns]="columns"
  [totalRecords]="totalRecords"
  [filterable]="true"
  [screenName]="screenName"
  [rows]="rows"
  [lazy]="true"
  (lazyLoad)="lazyLoad($event)"
  [loading]="isLoading"
  [includeExportCSV]="false"
  (changeViewEvent)="changeViewEvent($event)"
  scrollHeight="calc(100vh - 30vh)"
  [usePaginator]="true"
  [rowsPerPageOptions]="[50, 100, 200]"
  #grid
/>
<p-toast />
<p-confirmDialog
  header="Delete Note Confirmation"
  icon="pi pi-exclamation-triangle"
  key="aor-note-delete"
  rejectButtonStyleClass="p-button-danger"
/>
